export default {
  apiUrl: process.env.REACT_APP_API_URL,
  apiClient: process.env.REACT_APP_API_CLIENT,
  apiSecret: process.env.REACT_APP_API_SECRET,
};
